module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "praise"
  }, [_vm._v("Praise for the Queens of Camelot")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Risa: In Camelot’s Shadow ")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“Based on the famous poem ‘Sir Gawain and the Green Knight,’ this novel delivers passion, danger and excitement laced with fantasy.” —"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romantic Times Bookclub")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“Sarah Zettel incorporates elements of Arthurian legend into her story with flair, skill and lyrical writing. … "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("In Camelot’s Shadow ")]), _vm._v("is an engrossing and spellbinding tale and I can hardly wait for the sequel!” —"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bookloons")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“Zettel has brilliantly made a familiar story fresh and vibrant. The story just sings.” —"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romantic Science Fiction & Fantasy")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Elen: For Camelot’s Honor")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“An exciting and seductive journey laced with plenty of magic and romance.” —"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romantic Times Book Reviews")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“An intriguing story that fans of Arthurian legend will not want to miss.” —"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("CataRomance Reviews")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Lynet: Under Camelot’s Banner")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“High fantasy at its best.” —SFF Chronicles")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Under Camelot’s Banner")]), _vm._v("] is a blend of legend, myth and fantasy. … The author demonstrates a passion for the classic Arthurian story.” —Historical Novel Society")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Laurel: By Camelot’s Blood")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“A real happy ending takes love, effort, and sacrifice. Pick up a copy of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Camelot’s Blood ")]), _vm._v("if you want an epic romance!” —Silver Petticoat Reviews")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27645da5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm.vue
// module id = 66
// module chunks = 0